import * as Sentry from '@sentry/react';
import getRuntimeEnv from '../env';
/**
 * The default interceptor used by src/helpers/interceptConnect that will simply
 * fetch the given request and return its response without preocesing.
 * Only in the case of serverside error will this error be serialized to Sentry and
 * output tot he console.
 * @param input
 * @param init
 */
const sentryInterceptor = async (
  input: RequestInfo,
  init: RequestInit | undefined
): Promise<Response> => {
  const req = new Request(input, init);

  const response = await fetch(req);

  if (!response.ok) {
    // Log to console
    // eslint-disable-next-line no-console
    console.error(
      'An error occurred in an API request.',
      new Error(response.statusText),
      { response: response, requestUrl: req.url }
    );

    // Report to Sentry
    if (getRuntimeEnv().REACT_APP_SENTRY_DSN) {
      Sentry.captureException(new Error(response.statusText));
    }
  }
  return response;
};

export default sentryInterceptor;
